import React, { useEffect, useState } from "react";
import NoData from "../NoData/NoData";
import TableSkeleton from "../TableSkeleton";

import { mergeClass } from "../../utils/helper";
import classes from "./Table.module.css";

export default function Table({
  headings,
  tableData = [],
  loading,
  id,
  recordLimit = 25,
}) {
  const [emptyRows, setEmptyRows] = useState(0);

  useEffect(() => {
    // Calculate the number of empty rows to fill the body height dynamically
    const calculateEmptyRows = () => {
      const tableBodyHeight = window.innerHeight - 330; // Equivalent to calc(100vh - 425px)
      const rowHeight = 50; // Height of a single row
      const totalRows = Math.floor(tableBodyHeight / rowHeight); // Total possible rows that fit in the body
      const visibleRows = tableData?.length; // Number of rows with actual data

      return Math.max(totalRows - visibleRows, 0); // Calculate empty rows
    };

    // Update empty rows state when data or window height changes
    setEmptyRows(calculateEmptyRows());

    // Update the empty row count on window resize
    const handleResize = () => setEmptyRows(calculateEmptyRows());
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [tableData]);

  return (
    <>
      <style>
        {`
          .${classes.tableMainContainer} {
            --columns-to-show: ${headings?.length < 5 ? headings?.length : 5};
          }
        `}
      </style>

      <div className={mergeClass(classes.tableMainContainer)}>
        <div className={mergeClass(classes.tableHeader)}>
          <table>
            <thead>
              <tr>
                {headings?.map((item, index) => (
                  <th
                    key={`${item?.label}${index}`}
                    className={mergeClass(
                      "bodyOne fw-300 ",

                      // ...Object.values(classes),
                      index === headings?.length - 1
                        ? classes.noRightBorder
                        : ""
                    )}
                    style={
                      {
                        // ...(item?.style ?? {}),
                      }
                    }
                  >
                    {item?.label}
                  </th>
                ))}
              </tr>
            </thead>
          </table>
        </div>
        {loading ? (
          <TableSkeleton rowsCount={recordLimit} colsCount={headings?.length} />
        ) : (
          <div
            className={classes.tableBody}
            style={{ height: "calc(100vh - 425px)" }}
          >
            <table>
              <tbody>
                {tableData?.length > 0 ? (
                  <>
                    {[...tableData, ...Array.from({ length: emptyRows })]?.map(
                      (item, index) => (
                        <tr
                          className={mergeClass(
                            index === tableData?.length - 1
                              ? classes.noRightBorder
                              : "",
                            classes.border_radius,
                            (id && item?.transactionId === id) ||
                              (id && item?.slug === id)
                              ? classes.highlightRow
                              : ""
                          )}
                          key={index}
                        >
                          {headings?.map((a) => (
                            <td
                              className={mergeClass("td-black")}
                              key={a?.id + "" + index}
                              style={{
                                textAlign: "start",
                                // ...(a?.style ?? {}),
                              }}
                            >
                              <div
                                // className="maxLine1"
                                className={mergeClass(
                                  "maxLine1 bodyOne fw-300 ",
                                  classes.valueText
                                )}
                                style={{ ...(a?.bodyStyle ?? {}) }}
                              >
                                {item && a?.renderValue
                                  ? a?.renderValue(item, index)
                                  : item?.[a?.id]}
                              </div>
                            </td>
                          ))}
                        </tr>
                      )
                    )}
                  </>
                ) : (
                  <tr
                    className={mergeClass(
                      classes.noRightBorder,
                      classes.border_radius
                    )}
                    style={{
                      display: "contents",
                    }}
                  >
                    <td
                      className={mergeClass("td-black")}
                      style={{
                        textAlign: "start",
                      }}
                    >
                      <NoData />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
